import type {ExampleSeedDataConfig} from 'analysis-tool/create-analysis-modal/ExampleSeedDataConfigEditor';
import {AssayProcedureMethodInstanceSeedDataConfig} from 'notebook/worksheets/components/AssayProcedureMethodInstanceAnalysis';
import {RecipeProcedureRunSeedDataConfig} from 'studies/typed/process-development/RecipeProcedureRunAnalysis';

/**
 * Keep in sync with usages of `@register_seed_data_type` on the backend.
 */

export enum SeedDataConfigType {
  /**
   * This is an example for configuring seed data. Search all usages of `EXAMPLE_SEED_DATA`
   * on the frontend / backend to see how to properly register a new seed data configuration.
   */
  EXAMPLE_SEED_DATA = 'EXAMPLE_SEED_DATA',
  PROCEDURE_RUN = 'PROCEDURE_RUN',
  ASSAY_PROCEDURE_METHOD = 'ASSAY_PROCEDURE_METHOD',
}

/**
 * Union type of all possible seed data configurations. Each type should be a BaseSeedDataConfig.
 *
 * This shape should match the seed data configuration as handled by the backend.
 */
export type SeedDataConfig =
  | ExampleSeedDataConfig
  | RecipeProcedureRunSeedDataConfig
  | AssayProcedureMethodInstanceSeedDataConfig;

export interface BaseSeedDataConfig<T extends SeedDataConfigType, U> {
  type: T;
  data: U;
}
